<template>
  <div>
    <div class="modal__parking-zone-template-wrapper">
      <div v-if="descriptionTop" class="modal__description" v-html="descriptionTop"></div>
      <div v-if="staticParams.PARKING_ZONE_VIEW_ENABLE">
        <div v-if="carParkingSpots || carParkingSpots == 0" class="modal__parking-zone-box">
          <div class="modal__parking-zone-count">
            <div class="modal__subtitle">
              <translated-text-component translation="modal_parking_spaces_amount" />
            </div>
            <div class="modal__parking-zone-count-value">
              {{carParkingSpots}}
            </div>
          </div>
        </div>
        <div v-if="freeParkingSpots != null" class="modal__parking-zone-box">
          <div class="modal__parking-zone-count">
            <div class="modal__subtitle">
              <translated-text-component translation="modal_parking_free_spaces_amount" />
            </div>
            <div class="modal__parking-zone-count-value">
              {{freeParkingSpots}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent, onMounted, Ref, ref, watch,
} from 'vue';
import ModalTemplateService from '@/services/ModalTemplateService';
import { IModalData } from '@/services/layers/IModalData';
import store from '@/store';

const TemplateModalParkingZone: object = defineComponent({
  props: {
    templateData: {
      type: Object,
      required: true,
    },
  },
  name: 'TemplateModalParkingZone',
  setup(props) {
    const modalData: Ref<IModalData|null> = ref(null);
    const descriptionTop = ref('');
    const carParkingSpots = ref(0);
    const freeParkingSpots: Ref<number|null> = ref(null);
    const {staticParams} = store.state.settings;

    onMounted(() => {
      const { metaData } = props.templateData;
      descriptionTop.value = metaData.description;
      carParkingSpots.value = metaData.car_parking_spots;
      const lastStatus = metaData.last_status ? metaData.last_status : null;
      
      if (lastStatus) {
        const freeSpaces = carParkingSpots.value - lastStatus.occupied_parking_spots;
        freeParkingSpots.value = freeSpaces < 0
          ? 0
          : freeSpaces;
      }
    });

    return {
      modalData,
      descriptionTop,
      carParkingSpots,
      freeParkingSpots,
      staticParams,
    };
  },
});
export default TemplateModalParkingZone;
</script>

<style scoped lang="scss">
.modal__subtitle {
  font-size: rem(16px);
  font-weight: 700;
  margin-bottom: rem(12px);
}

.modal__parking-spots {
  &-template-wrapper {
    display: flex;
    justify-content: center;
    text-align: center;
    margin-bottom: rem(32px);
  }

  &-free-box {
    margin-top: rem(22px);
  }

  &-list {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 rem(-22px);
  }

  &-item {
    display: flex;
    align-items: center;
    padding: 0 rem(22px);
  }

  &-icon {
    font-size: rem(24px);
    color: $modal-parking_standard_icon;
    margin-right: rem(15px);
  }


}
.modal__parking-zone {
  &-box {
    text-align: center;
    margin-bottom: 14px;
  }

  &-count {
    &-value {
      font-weight: 700;
    }
  }
}
</style>
